import React from "react";

import "../style/reset.css"
import "../style/typography.css"

import SEO from "../components/seo";
import styled, {ThemeProvider} from "styled-components";
import {useThemes} from "../style/themes.hook";
import {CookiesProvider} from "react-cookie";
import {FullWidthContainer, InternalLink} from "../style/itf-styled-components";
import Header from "../components/header/header";
import CookiesConsent from "../components/cookies-consent";
import Footer from "../components/footer";
const Button = styled.div`
  font-family: "Playfair Display",sans-serif;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.colors.neutrals._900};
  
  :hover {
    background-color: ${props => props.theme.colors.secondary._500};
    color: ${props => props.theme.colors.neutrals._000};
  }
`;

const Agenda = () => {
  const themes = useThemes();

  return (
    <>
      <CookiesProvider>
        <SEO
          title={`Agendă - Imagine Timisoara Festival 2021`}
          description={`Imagine Timisoara Festival, ajuns la cea de-a treia ediție, este un proiect al Asociației Imagine Timisoara.`}
        />
      </CookiesProvider>

      <ThemeProvider theme={themes.light}>
        <Header page="agenda"/>
        <FullWidthContainer
          css={`
            padding: 30px 25px 60px 25px;
            flex-direction: row;
            font-size: 4vw;
            height: calc(100vh - 80px);
            justify-content: center;
            
            @media (max-width: ${props => props.theme.mobileWidth}) {
              flex-direction: column;
            }
          `}
        >
          <Button as={InternalLink} to={'/agenda-conferinte'}>Conferințe</Button>
          <Button as={InternalLink} to={'/agenda-workshopuri'}>Workshopuri</Button>

        </FullWidthContainer>

        <Footer/>

        <CookiesProvider>
          <CookiesConsent/>
        </CookiesProvider>
      </ThemeProvider>
    </>
  );
};

export default Agenda
